import './XuHuongDongTien.scss'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HC_more from 'highcharts/highcharts-more.src'
import { useDispatch, useSelector } from 'react-redux'
import { getDetailStock } from 'store/actionReducers/TrendStore'
import SearchInput from './SearchInput'
import TabFilter from './TabFilter'
import { options } from './XuHuongDongTienConfig'
import useMarket from 'hook/useMarket'
import { useEffect, useState } from 'react'
import { setMarketCashflow } from 'store/actionReducers/MarketStore'
import { Spin } from 'antd'

HC_more(Highcharts)

export default function XuHuongDongTien() {
  const CommnonStore = useSelector((state) => state?.CommnonStore)
  const MarketStore = useSelector((state) => state?.MarketStore)
  const TrendStore = useSelector((state) => state?.TrendStore)
  const LoadingStore = useSelector((state) => state?.LoadingStore)
  const { fetchCashflow, filterCashflow } = useMarket();
  const dispatch = useDispatch()

  useEffect(() => {
    fetchCashflow({ category: TrendStore?.tabFilter })
  }, [TrendStore?.tabFilter])

  const handleDetailBranch = (type, data) => {
    dispatch(setMarketCashflow([]))
    dispatch(getDetailStock({ ...TrendStore, step: type, data: data }))
  }

  const handleClickFilter = (tab) => {
    dispatch(getDetailStock({ ...TrendStore, step: '', tabFilter: tab }))
  }

  return (
    <>
      <SearchInput />
      <TabFilter tabActiveDefault={TrendStore?.tabFilter} clickFilter={(value) => handleClickFilter(value)} />
      <div className='odnikstzbm'>
        <div className='xbjjvdsfqt'>
          <div className='kccxtosxja gbuaeclvej crWGjAyNVr'>
            <div className='dqrlvqggzk ncmaxresbt'>Ngành</div>
            {/* <div className='dqrlvqggzk fvweysihdv'>Vốn hóa</div> */}
            <div className='dqrlvqggzk yjkkqkfpyp'>Cổ phiếu tích cực</div>
            <div className='dqrlvqggzk omcmnkuijs'>Cổ phiếu tiêu cực</div>
          </div>
          <Spin spinning={LoadingStore?.loading.indexOf('AllCashFlow') > -1}>
            <div className='xizvgwhqml'>
              <div className='cavjxmogtp'>
                {
                  MarketStore?.marketCashflow && MarketStore?.marketCashflow.length > 0 ? MarketStore?.marketCashflow.map((item, key) => {
                    return (
                      <div className='kccxtosxja elqqrpfvve' key={key}>
                        <div className='dqrlvqggzk ncmaxresbt GbTSEwmJcG' onClick={() => handleDetailBranch('branch', { icbcode: item?.icbcode })}>{item?.icbname}</div>
                        <div className='dqrlvqggzk yjkkqkfpyp'>
                          {
                            item?.stockPositive && item?.stockPositive.length > 0 ? item?.stockPositive.map((item2, key2) => {
                              return (
                                <span className='fpqptzczsq' key={key2} onClick={() => handleDetailBranch('code', { stock: item2 })}>
                                  {item2}{item?.stockPositive.length - 1 > key2 && item?.stockPositive.length > 0 && `,`}
                                </span>
                              )
                            }) : null
                          }
                        </div>
                        <div className='dqrlvqggzk omcmnkuijs'>
                          {
                            item?.stockNegative && item?.stockNegative.length > 0 ? item?.stockNegative.map((item2, key2) => {
                              return (
                                <span className='fpqptzczsq' key={key2} onClick={() => handleDetailBranch('code', { stock: item2 })}>
                                  {item2}{item?.stockNegative.length - 1 > key2 && item?.stockNegative.length > 0 && `,`}
                                </span>
                              )
                            }) : null
                          }
                        </div>
                      </div>
                    )
                  }) : null
                }
              </div>
            </div>
          </Spin>
        </div>
        <div className='oljolmldcu'>
          <div className='hayvdmtnvu'>
            <div className="awopotuuhp">
              <HighchartsReact
                highcharts={Highcharts}
                options={options(filterCashflow(MarketStore?.marketCashflow), handleDetailBranch, CommnonStore)}
              />
            </div>

            <div className='nxcbyjafuq'>Hồi phục</div>
            <div className='jlhsvdrypk'>Tăng mạnh</div>
            <div className='bcexoqlpqp'>Giảm mạnh</div>
            <div className='bdixkxbncj'>Suy yếu</div>
          </div>
        </div>
      </div>
    </>
  )
}